module.exports = __webpack_public_path__ + "img/apple-logo-black.baa24b8e.svg";